module.exports = __webpack_public_path__ + "img/not-found.66686e6d.png";